// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background: #fff;
  border-top: 1px solid var(--border);
  padding: 48px 20px 28px;
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr;
  gap: 40px;
  margin-bottom: 40px;
}

.footer-brand { display: flex; flex-direction: column; gap: 10px; }

.footer-logo {
  display: flex;
  align-items: center;
  gap: 9px;
}

.footer-logo-img{height:90px;width:auto;display:block}

.footer-desc {
  font-size: 0.85rem;
  color: var(--muted);
  line-height: 1.6;
  max-width: 240px;
}

.footer-col h4 {
  font-size: 0.82rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--muted);
  margin-bottom: 14px;
}

.footer-col a {
  display: block;
  font-size: 0.88rem;
  color: var(--text);
  text-decoration: none;
  margin-bottom: 9px;
  transition: color 0.2s;
}
.footer-col a:hover { color: var(--p1); }

.footer-whatsapp {
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
  color: #25D366 !important;
  font-weight: 600;
  margin-top: 4px;
}
.footer-whatsapp:hover { color: #1ebe57 !important; }

.footer-bottom {
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 24px;
  border-top: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.footer-copy {
  font-size: 0.82rem;
  color: var(--muted2);
}

.footer-socials {
  display: flex;
  gap: 10px;
}

.social-btn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: var(--bg);
  border: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--muted);
  text-decoration: none;
  transition: color 0.2s, border-color 0.2s;
}
.social-btn:hover { color: var(--social-color, var(--p1)); border-color: var(--social-color, var(--p1)); }

@media (max-width: 640px) {
  .footer-inner { grid-template-columns: 1fr; gap: 28px; }
  .footer-bottom { flex-direction: column; align-items: flex-start; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;AACrB;;AAEA,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAElE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,iBAAiB,WAAW,CAAC,UAAU,CAAC,aAAa;;AAErD;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;AACA,sBAAsB,gBAAgB,EAAE;;AAExC;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;AACA,yBAAyB,yBAAyB,EAAE;;AAEpD;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,mCAAmC;EACnC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;AACA,oBAAoB,qCAAqC,EAAE,4CAA4C,EAAE;;AAEzG;EACE,gBAAgB,0BAA0B,EAAE,SAAS,EAAE;EACvD,iBAAiB,sBAAsB,EAAE,uBAAuB,EAAE;AACpE","sourcesContent":[".footer {\n  background: #fff;\n  border-top: 1px solid var(--border);\n  padding: 48px 20px 28px;\n}\n\n.footer-inner {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1.5fr 1fr 1fr;\n  gap: 40px;\n  margin-bottom: 40px;\n}\n\n.footer-brand { display: flex; flex-direction: column; gap: 10px; }\n\n.footer-logo {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n}\n\n.footer-logo-img{height:90px;width:auto;display:block}\n\n.footer-desc {\n  font-size: 0.85rem;\n  color: var(--muted);\n  line-height: 1.6;\n  max-width: 240px;\n}\n\n.footer-col h4 {\n  font-size: 0.82rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: var(--muted);\n  margin-bottom: 14px;\n}\n\n.footer-col a {\n  display: block;\n  font-size: 0.88rem;\n  color: var(--text);\n  text-decoration: none;\n  margin-bottom: 9px;\n  transition: color 0.2s;\n}\n.footer-col a:hover { color: var(--p1); }\n\n.footer-whatsapp {\n  display: inline-flex !important;\n  align-items: center;\n  gap: 6px;\n  color: #25D366 !important;\n  font-weight: 600;\n  margin-top: 4px;\n}\n.footer-whatsapp:hover { color: #1ebe57 !important; }\n\n.footer-bottom {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding-top: 24px;\n  border-top: 1px solid var(--border);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.footer-copy {\n  font-size: 0.82rem;\n  color: var(--muted2);\n}\n\n.footer-socials {\n  display: flex;\n  gap: 10px;\n}\n\n.social-btn {\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  background: var(--bg);\n  border: 1px solid var(--border);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--muted);\n  text-decoration: none;\n  transition: color 0.2s, border-color 0.2s;\n}\n.social-btn:hover { color: var(--social-color, var(--p1)); border-color: var(--social-color, var(--p1)); }\n\n@media (max-width: 640px) {\n  .footer-inner { grid-template-columns: 1fr; gap: 28px; }\n  .footer-bottom { flex-direction: column; align-items: flex-start; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
